import { render, staticRenderFns } from "./meb-carousel.vue?vue&type=template&id=608dd01c&scoped=true&"
import script from "./meb-carousel.vue?vue&type=script&lang=js&"
export * from "./meb-carousel.vue?vue&type=script&lang=js&"
import style0 from "./meb-carousel.vue?vue&type=style&index=0&id=608dd01c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608dd01c",
  null
  
)

export default component.exports